import DOMPurify from "dompurify";

// Exactly the portal backend's sanitiser allow-list (nh3), so the two can never disagree.
export const ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "ol",
  "ul",
  "li",
  "a",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
];
export const ALLOWED_ATTR = ["href", "colspan", "rowspan"];
export const ALLOWED_URI_REGEXP = /^(?:https?|mailto):/i;

let configured = false;
function configure(): void {
  if (configured) return;
  configured = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.nodeName === "A" && node.hasAttribute("href")) {
      node.setAttribute("rel", "noopener noreferrer");
      node.setAttribute("target", "_blank");
    }
  });
}

/** Policy HTML reduced to the markup the editor can produce. Relative links are dropped (stricter than the backend). */
export function sanitizePolicyHtml(html: string): string {
  configure();
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
    // Non-URL attributes are otherwise checked against ALLOWED_URI_REGEXP, which drops colspan="2".
    ADD_URI_SAFE_ATTR: ["colspan", "rowspan"],
  });
}
